module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"needAccept":"Need confirmation from driver","title":"Driver"},"no":{"needAccept":"Trenger bekreftelse fra sjåfør","title":"Sjåfør"}}')
  delete Component.options._Ctor
}
